

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

/*Services*/
import { CachedDataService } from '@services/data/cached-data.service';
import { ScreenService } from '@services/screen.service';
import { UserService } from '@services/http/user.service';

/*Models */
import { User } from '@models/user';

import { regexValidators } from '../../../validator';

import { BsModalComponent } from 'ng2-bs3-modal';
import {Router} from "@angular/router";
declare var swal: any;


@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.component.html'
})

export class ProfileModalComponent implements OnInit {

  @ViewChild('profileModal') profileModal: BsModalComponent;
  userForm: FormGroup;
  currentUser: User;
  trySend = false;

  errorMessage = '';

  btnText = {
    text: 'Сохранить',
    default: 'Сохранить',
    loadText: 'Сохранение..'
  };
  constructor(
    private cachedDataService: CachedDataService,
    private formBuilder: FormBuilder,
    private screenService: ScreenService,
    private userService: UserService,
    private router: Router) {
  }

  ngOnInit() {
    this.screenService.isShowLoader = false;
  }

  initForm() {
    this.userForm = this.formBuilder.group({
      FullName: ['', [Validators.required]],
      Email: ['', [Validators.required, Validators.pattern(regexValidators.email)]],
      PhoneNumber: [''],
      Id: '',
      dateTimeOffset: ''
    });
  }

  submit() {
    if (this.trySend) {
      return false;
    }

    if (this.userForm.invalid) {
      const controls = this.userForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }

    this.trySend = true;
    this.btnText.text = this.btnText.loadText;

    this.userService.updateUserInfo(
      this.userForm.value.FullName,
      this.userForm.value.Email,
      this.userForm.value.Id,
      this.userForm.value.dateTimeOffset)
      .subscribe(
        response => {
          this.trySend = false;
          this.currentUser.fullName = this.userForm.value.FullName;
          this.currentUser.email = this.userForm.value.Email;
          this.cachedDataService.setCurrentUser(response);
          this.currentUser = this.cachedDataService.getCurrentUser();
          this.close();
          swal({
            type: 'success',
            text: 'Данные обновлены',
            showConfirmButton: false,
            timer: 3000,
          });
          this.errorMessage = null;
        },
        error => {
          this.trySend = false;
          this.btnText.text = this.btnText.default;
          if (error.error.errorMessage.length) {
            this.errorMessage = error.error.errorMessage;
          } else {
            const errors = error.error.modelState;
            // tslint:disable-next-line:forin
            for (error in errors) {
              this.userForm.controls[errors[error].field.toLowerCase()].setErrors({ 'error': errors[error].errors });
            }
          }
        });
  }


  navigateToAccountDeleting() {
    this.router.navigate(['/account-delete']);
    this.close()
  }
  open() {
    this.btnText.text = this.btnText.default;
    this.errorMessage = null;
    this.currentUser = this.cachedDataService.getCurrentUser();
    this.initForm();
    if (this.currentUser.fullName) {
      this.userForm.controls['FullName'].setValue(this.currentUser.fullName);
    }
    if (this.currentUser.email) {
      this.userForm.controls['Email'].setValue(this.currentUser.email);
    }
    if (this.currentUser.phoneNumber) {
      this.userForm.controls['PhoneNumber'].setValue(this.currentUser.phoneNumber);
    }

    if (this.currentUser.dateTimeOffset) {
      this.userForm.controls['dateTimeOffset'].setValue(this.currentUser.dateTimeOffset);
    }

    this.userForm.controls['Id'].setValue(this.currentUser.id);

    this.profileModal.open();
  }

  close() {
    this.profileModal.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/profile-modal/profile-modal.component.ts